import * as React from "react";
import { forwardRef } from "react";
const SvgUnread = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 3H20C21 3 22.0001 4 22.0001 5V19.0003C22.0001 20 21 21 20 21H14C13 21 6 13 6 13H2V11H6C6 11 13 3 14 3Z" }));
const ForwardRef = forwardRef(SvgUnread);
export { ForwardRef as ReactComponent };
